import { API, graphqlOperation } from 'aws-amplify';
import { getAdminPanelData } from '../../../graphql/queries';
import { groupNameDescriptionMap } from './adminpanel-constants'
import { EventTypes } from './permissionTabTypes';
import { notificationType } from '../../../types/notifications';



export const mutateUserGroups = async (
  inputEmail: string,
  inputEventType: EventTypes,
  inputTargetGroup: string,
  inputUserName: string,
  inputUserPoolId: string,
  setNotificationState: any
) => {
  try {
    const result = await API.graphql(
      graphqlOperation(getAdminPanelData, {
        adminPanelLambdaInput: {
          email: inputEmail,
          eventType: inputEventType,
          targetGroup: inputTargetGroup,
          userName: inputUserName,
          userPoolId: inputUserPoolId,
        },
      })
    );

    const groupName = groupNameDescriptionMap.find(
      (groupObj) => groupObj.cognitoGroupName === inputTargetGroup
    )?.groupName;

    const eventName =
      inputEventType === 'addUser' ? 'added to' : 'removed from';

    const title = `User Successfully ${eventName} the ${groupName} Group!`;

    setNotificationState({
      open: true,
      title,
      content: '',
      level: 'success',
    });
    return result;
  } catch (e) {
    console.log(
      `${inputEventType === 'addUser' ? 'Addition' : 'Removal'} failed with`,
      e
    );
    setNotificationState({
      open: true,
      title: 'An error occurred. Please check the console for more details!',
      content: '',
      level: 'error',
    });
  }
};

export const updateUserMarket = async (
  inputEmail: string,
  inputUserName: string,
  inputUserPoolId: string,
  market: string,
  setNotificationState: React.Dispatch<React.SetStateAction<notificationType>>
) => {
  try {
    const result = await API.graphql(
      graphqlOperation(getAdminPanelData, {
        adminPanelLambdaInput: {
          eventType: 'updateUserMarket',
          email: inputEmail,
          targetGroup: '',
          userName: inputUserName,
          userPoolId: inputUserPoolId,
          market,
        },
      })
    );
    setNotificationState({
      open: true,
      title: `User markets were successfully updated!`,
      content: '',
      level: 'success',
    });
    return result;
  } catch (e) {
    console.error(e);
    setNotificationState({
      open: true,
      title: 'An error occurred. Please check the console for more details!',
      content: '',
      level: 'error',
    });
  }
};
